
export const stage =
  (window as { __limberStage?: string }).__limberStage || 'local';
